import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
export const CHECKOUT_URL = 'https://decisionclinica.impultienda.ar/checkout/obesidad';
type Props = {
  label?: string;
  sublabel?: string;
  size?: 'md' | 'lg';
  pulse?: boolean;
  id?: string;
  className?: string;
  onDark?: boolean;
};
export function CTAButton({
  label = 'QUIERO EL KIT CLÍNICO AHORA',
  sublabel,
  size = 'lg',
  pulse = true,
  id,
  className = '',
  onDark = false
}: Props) {
  return <div className={`w-full flex flex-col items-center ${className}`} data-id="element-67" data-mp="2oz8ca1q1vkri">
      <a id={id} href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} className={`${pulse ? 'cta-pulse' : ''} group inline-flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-brandblue text-center font-extrabold uppercase tracking-wide text-white shadow-lg shadow-brandblue/25 transition-all duration-200 hover:bg-brandblue-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-brandblue/40 ${size === 'lg' ? 'px-5 py-4 text-[15px] leading-tight sm:text-lg sm:py-5' : 'px-4 py-3.5 text-[13px] leading-tight sm:text-base'}`} data-id="element-68" data-mp="33owcezmhwddn">
        <span className="break-words" data-id="element-69" data-mp="1ibnwvbedyhxa">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-70" data-mp="1n8xuhebxhzw7" />
      </a>
      {sublabel && <p className={`mt-3 px-2 text-center text-[12px] font-medium leading-relaxed sm:text-sm ${onDark ? 'text-white/65' : 'text-navy/60'}`} data-id="element-71" data-mp="1s5o9dybzypg1">
          {sublabel}
        </p>}
    </div>;
}